module.exports = __webpack_public_path__ + "static/img/e5b6d3ade07907d29b42d808dd1cc3a8.product1.1709800931122.png";